import {Inject, Injectable, makeStateKey, PLATFORM_ID, StateKey, TransferState} from '@angular/core';
import {isPlatformBrowser, isPlatformServer} from "@angular/common";
import {Observable, of, tap} from "rxjs";

interface CacheEntry<T> {
  data: T;
  expiresAt: number;
}

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  trackingAll = "hotjar;pixel-meta;google-analytics"
  public trackings = [
    {
      name: "Hotjar",
      description: "Outil pour mesurer l'audience du site",
      tag: "hotjar",
      accept: false,
      code: `
      (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:6638571,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `
    },
    {
      name: "Pixel Meta",
      description: "Outil de suivi de conversion Facebook et Instagram",
      tag: "pixel-meta",
      accept: false,
      code: `
      <!-- Meta Pixel Code -->
      <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '925016983578939');
      fbq('track', 'PageView');
      </script>
      <noscript><img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=925016983578939&ev=PageView&noscript=1"
      /></noscript>
      <!-- End Meta Pixel Code —>
      `
    },
    {
      name: "Google Analytics",
      description: "Outil de suivi de consultation des pages web",
      tag: "google-analytics",
      accept: false,
      code: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-KMJY2YRTSF');
      gtag('config', 'AW-17957647111');
      `
    }
  ]
  alreadyTracked = false

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
  }

  initAllTracking() {
    if(this.alreadyTracked) {
      return
    }
    let expiry = new Date()
    expiry.setDate(expiry.getDate()+365)
    let trackings = this.trackingAll.split(";")
    trackings.forEach(tag => this.addCode(tag))
    this.alreadyTracked = true
  }

  addCode(tag: string) {
    if(isPlatformBrowser(this.platformId)) {
      let tracking = this.trackings.find(c => c.tag == tag)
      let node = document.createElement('script'); // creates the script tag
      node.src = ''; // sets the source (insert url in between quotes)
      node.type = 'text/javascript'; // set the script type
      node.async = true; // makes script run asynchronously
      node.charset = 'utf-8';
      node.textContent = tracking.code
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
